import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Article} from './article';

@Injectable()
export class ArticleService {
  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all articles which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.articleURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(article : Article) {
    console.log('Push article to insert method of service.');
    article.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(article));
    return this.http.post(this.config.articleURL+"new", JSON.stringify(article), {headers: this.headers});
  }

  public update(article : Article) {
    console.log('Push article to insert method of service.');
    article.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(article));
    return this.http.put(this.config.articleURL+"id/"+article.id, JSON.stringify(article), {headers: this.headers});
  }

  public qryArticle(id : number) {
    return this.http.post(this.config.articleURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete article '+ id);
    return this.http.post(this.config.articleURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article/article.service.ts